export default __webpack_public_path__ + "static/spectory_logo_white-c2ed2a0b55a00e3ae4feff6876e17c74.png";